import { repositoryPos } from "../_base/_const/_constVar";

// Enum định nghĩa các loại quyền
export enum AuthType {
  NO_PERMISSION = 0, // Không có quyền
  LIMITED_PERMISSION = 1, // Quyền hạn chế
  FULL_PERMISSION = 2, // Quyền đầy đủ (Admin)
}

export interface UserAuthResponse {
  id: string;
  typeAtuh: number; // 0, 1, 2 - quyền của user
  empid: number;
  createBy: string;
  createDate: string;
  lastupdateBy: string | null;
  lastupdateDate: string | null;
  listOrgId: string;
}

export const apiAuth = {
  /**
   * Lấy thông tin quyền của user đang login
   */
  getUserAuth: async (): Promise<any> => {
    try {
      const response = await repositoryPos.get<any>("/api/v1/AuthApprove/user");
      return response || null;
    } catch (error) {
      console.error("Error fetching user auth:", error);
      return null;
    }
  },
};
